define('sections/email_subscriptions/Podio.UI.EmailSubscriptions.Edit',['require','underscore','jquery','lib/Podio.Event.UI','lib/Podio.Event','webnotification'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var WebNotification = require('webnotification');

  function initMasterCheckboxes() {

    _.each($('.email_subscriptions .email dl.master input[type=checkbox]'), function(item) {
      var elmMasterCheckbox = $(item);
      var elmSubCheckboxes = elmMasterCheckbox.closest('.settings-box').find('dl.sub input[type=checkbox]');

      elmMasterCheckbox.prop('checked', !elmSubCheckboxes.filter(':not(:checked)').length);
    });

    if (!$('#email_subscription_setting_push_notification').attr('checked')) {
      $('.email_subscriptions .push dl.sub').addClass('inactive');
    }
  }

  function onInit() {
    initMasterCheckboxes();
  }

  function onSubListCheckboxChange(e) {
    initMasterCheckboxes();
  }

  function onMasterCheckboxChange(elmTarget, e) {
    var elmCheckboxes = elmTarget.closest('.settings-box').find('dl.sub input[type=checkbox]');
    elmCheckboxes.prop('checked', elmTarget.prop('checked'));
  }

  function onPushMasterCheckboxChange(elmTarget, e) {
    $('.email_subscriptions .push dl.sub input[type=checkbox]').prop('checked', elmTarget.prop('checked')).trigger('change');
    if (elmTarget.prop('checked')) {
      $('.email_subscriptions .push dl.sub').removeClass('inactive');
    } else {
      $('.email_subscriptions .push dl.sub').addClass('inactive');
    }
  }

  function onPushSubCheckboxChange(elmTarget, e) {
    if (elmTarget.is(':checked')) {
      $('.email_subscriptions .push dl.sub').removeClass('inactive');
      $('.email_subscriptions .push dl.master input[type=checkbox]').prop('checked', true);
    }

    if ( elmTarget.is(':checked') && elmTarget.is('#email_subscription_setting_push_notification_browser') ) {

      if (!WebNotification.isSupported()) {
        return;
      }

      WebNotification.requestPermission();

    }

  }

  podioEvent.bind(podioEvent.Types.init, onInit);
  eventUI.bind('change', '.email_subscriptions .email dl.sub.sync input[type=checkbox]', onSubListCheckboxChange, true);
  eventUI.bind('change', '.email_subscriptions .email dl.master input[type=checkbox]', onMasterCheckboxChange, true);
  eventUI.bind('change', '.email_subscriptions .push dl.master input[type=checkbox]', onPushMasterCheckboxChange, true);
  eventUI.bind('change', '.email_subscriptions .push dl.sub input[type=checkbox]', onPushSubCheckboxChange, true);

});

